import {
  FETCH_PRODUCTS,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_ERROR,
  FETCH_PRODUCT_DETAILS,
  FETCH_PRODUCT_DETAILS_SUCCESS,
  FETCH_PRODUCT_DETAILS_ERROR,
  CHANGE_PRODUCT_DETAILS,
  FETCH_PRODUCT_REVIEWS,
  FETCH_PRODUCT_REVIEWS_SUCCESS,
  FETCH_PRODUCT_REVIEWS_ERROR,
  FETCH_RELATED_PRODUCTS,
  FETCH_RELATED_PRODUCTS_SUCCESS,
  FETCH_RELATED_PRODUCTS_ERROR,
  UPDATE_RECENTLY_VIEWED,
  UPDATE_RECENTLY_VIEWED_SUCCESS,
  UPDATE_RECENTLY_VIEWED_ERROR,
} from '../actionTypes';

export const fetchProducts = (data) => ({
  type: FETCH_PRODUCTS,
  payload: data,
});

export const fetchProductsSuccess = (user, pageData) => ({
  type: FETCH_PRODUCTS_SUCCESS,
  payload: user,
  pageData,
});

export const fetchProductsError = (message) => ({
  type: FETCH_PRODUCTS_ERROR,
  payload: message,
});

export const fetchProductReviews = (data) => ({
  type: FETCH_PRODUCT_REVIEWS,
  payload: data,
});

export const fetchProductReviewsSuccess = (user, pageData) => ({
  type: FETCH_PRODUCT_REVIEWS_SUCCESS,
  payload: user,
  pageData,
});

export const fetchProductReviewsError = (message) => ({
  type: FETCH_PRODUCT_REVIEWS_ERROR,
  payload: message,
});

export const fetchProductDetails = (data) => ({
  type: FETCH_PRODUCT_DETAILS,
  payload: data,
});

export const fetchProductDetailsSuccess = (user) => ({
  type: FETCH_PRODUCT_DETAILS_SUCCESS,
  payload: user,
});

export const fetchProductDetailsError = (message) => ({
  type: FETCH_PRODUCT_DETAILS_ERROR,
  payload: message,
});

export const changeProductDetails = (data) => ({
  type: CHANGE_PRODUCT_DETAILS,
  payload: data,
});

export const fetchRelatedProducts = (data) => ({
  type: FETCH_RELATED_PRODUCTS,
  payload: data,
});

export const fetchRelatedProductsSuccess = (user) => ({
  type: FETCH_RELATED_PRODUCTS_SUCCESS,
  payload: user,
});

export const fetchRelatedProductsError = (message) => ({
  type: FETCH_RELATED_PRODUCTS_ERROR,
  payload: message,
});

export const updateRecentlyViewed = (data) => ({
  type: UPDATE_RECENTLY_VIEWED,
  payload: data,
});

export const updateRecentlyViewedSuccess = (user) => ({
  type: UPDATE_RECENTLY_VIEWED_SUCCESS,
  payload: user,
});

export const updateRecentlyViewedError = (message) => ({
  type: UPDATE_RECENTLY_VIEWED_ERROR,
  payload: message,
});
